<template>
  <div>
    <vs-table id="rm-order-item-table" :hoverFlat="true" stripe :data="raw_material_items">

      <template slot="thead">
        <vs-th width="10%" class="text-xs">ITS PRODUCT CODE</vs-th>
        <vs-th width="15%" class="text-xs">ITS PRODUCT NAME</vs-th>
        <vs-th width="5%" class="text-xs">UNIT</vs-th>
        <vs-th width="10%" class="text-xs">TOTAL ITEM QUANTITY</vs-th>
        <vs-th width="10%" class="text-xs">RMs NOT YET RECEIVED</vs-th>
        <vs-th width="5%" class="text-xs">PRICE/KG (GBP)</vs-th>
        <vs-th v-if="raw_material_items[0].currency !== 'GBP'" width="5%" class="text-xs">PRICE/KG ({{ raw_material_items[0].currency }})</vs-th>
        <vs-th width="10%" class="text-xs">PAYMENT STATUS</vs-th>
        <vs-th width="15%" class="text-xs">ITEM STATUS</vs-th>
        <vs-th width="10%"  class="justify-end ml-auto mr-0 text-xs">TOTAL PRICE (GBP)</vs-th>
        <vs-th width="5%" class="text-xs">ACTION</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr class="text-sm" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td class="font-semibold" :data="data[indextr].company_product_code">
            <span style="cursor: pointer" @click.stop="viewRawMaterial(data[indextr])">{{data[indextr].category.prefix}}-{{ data[indextr].company_product_code }}</span>
          </vs-td>

          <vs-td :data="data[indextr].company_product_name">
            {{ data[indextr].company_product_name }}
          </vs-td>

          <vs-td :data="data[indextr].unit">
            {{ data[indextr].unit }}
          </vs-td>

          <vs-td :data="data[indextr].quantity">
            {{ Number(data[indextr].quantity).toFixed(4) }}
          </vs-td>

          <vs-td :data="data[indextr].quantity_pending_to_receive">
            {{ Number(data[indextr].quantity_pending_to_receive).toFixed(4) }}
          </vs-td>

          <vs-td :data="data[indextr].gbp_price">
            {{ (Number(data[indextr].gbp_price)).toFixed(2) }}
          </vs-td>

          <vs-td :data="data[indextr].price" v-if="raw_material_items[0].currency !== 'GBP'">
            {{ (Number(data[indextr].price)).toFixed(2) }}
          </vs-td>

          <!-- <vs-td :data="data[indextr].payment_status">
            {{ generatePaymentStatus(data[indextr].q_c_test) }}
          </vs-td> -->

          <vs-td :data="data[indextr].payment_status">
            {{ generatePaymentStatus(data[indextr]) }}
          </vs-td>

          <vs-td :data="data[indextr].item_status">
            <vs-dropdown  vs-trigger-click class="cursor-pointer" v-if="raw_material_items.length > 1">
              <a class="flex items-center text-dark ml-1" href="#">
                <vs-chip v-if="data[indextr].item_status" style="border-radius: 0" class="text-center text-xs" transparent :color="itemStatusColorFactory(data[indextr].item_status)">
                  <!-- {{ itemStatusGenerator(data[indextr].item_status, tr.inventory_items, tr.quantity_pending_to_receive)}} -->
                    {{ data[indextr].item_status }}
                </vs-chip>
                <i class="material-icons"> expand_more </i>
              </a>
              <vs-dropdown-menu v-can="'create-edit-raw-material-orders'">
                <vs-dropdown-item class="w-64"
                                  @click.stop="onClickChangeItemStatus(data[indextr].id, status.name)"
                                  v-for="status in raw_material_order_item_statuses"
                                  v-bind:key="status.name"
                                  v-if="itemStatusManager(status.name, data[indextr].item_status) && status.name !== data[indextr].item_status && status.visible">
                  {{ statusNameFactory(status.name) }}
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <vs-chip v-else style="border-radius: 0" class="text-center text-xs" transparent :color="itemStatusColorFactory(data[indextr].item_status)">
              <!-- {{ itemStatusGenerator(data[indextr].item_status, tr.inventory_items, tr.quantity_pending_to_receive) }} -->
                {{ data[indextr].item_status }}
            </vs-chip>
          </vs-td>

          <vs-td  class="flex justify-end mr-4" :data="data[indextr].gbp_price">
            {{data[indextr].quantity ? (Number(data[indextr].gbp_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
          </vs-td>

          <vs-td>
            <div class="vx-row">
              <vx-tooltip v-can="'create-edit-raw-material-orders-qc-test'"
                          v-if="['Received', 'Received - QC Passed'].includes(data[indextr].item_status)"
                          class="flex justify-start mr-2" text="Manage batches & QC tests" position="top">
                <vs-button class="flex justify-end"
                           size="small" color="success" type="border" icon-pack="feather" icon="icon-git-branch"></vs-button>
              </vx-tooltip>
            </div>
          </vs-td>

          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-4/5">
              <!-- <vs-table :hoverFlat="true" class="mt-8 mb-8" :data="tr.q_c_test"> -->

              <vs-table :hoverFlat="true" class="mt-8 mb-8" :data="tr.inventory_items">

                <template slot="header">
                  <h5 class="mb-4">RM BATCH</h5>
                  <div class="flex mb-4">
                        <vs-button
                         v-if="Number(tr.quantity_pending_to_receive) > 0"
                          @click.stop="onClickCreateBatch(tr)"
                          color="primary" size="small" type="border" >Book in RM Batch</vs-button>
                  </div>
                </template>

                <template slot="thead">
                  <vs-th >BATCH CODE</vs-th>
                  <vs-th >BATCH BOOK IN DATE</vs-th>
                  <vs-th >BATCH STATUS</vs-th>
                  <vs-th >SUB BATCH PART NO</vs-th>
                  <vs-th >RECEIVED QUANTITY(kg)</vs-th>
                  <vs-th >WAREHOUSED</vs-th>
                  <vs-th >BATCH EXPIRY DATE</vs-th>
                  <vs-th >QC TASTE PANEL STATUS</vs-th>
                  <vs-th >QC RELEASE STATUS</vs-th>
                  <vs-th >ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="index_qc_test" v-for="(tr_qc, index_qc_test) in data">

                    <vs-td :data="tr_qc.code">
                      {{ tr_qc.code }}
                    </vs-td>
                    <vs-td :data="tr_qc.created_at">
                      {{ __dateTimeFormatterToDate(tr_qc.created_at) }}
                    </vs-td>
                    <vs-td :data="tr_qc.status">
                      {{ tr_qc.status | stock_status_format }}
                    </vs-td>
                    <vs-td :data="tr_qc.batch_part_no">
                      {{ tr_qc.batch_part_no }}
                    </vs-td>
                    <vs-td :data="tr_qc.total_quantity">
                      {{ __removeTrailingZeros(tr_qc.total_quantity) }}
                    </vs-td>
                     <vs-td class="text-bold">
                      {{ !!tr_qc.shelf_location_l ? 'Yes' : 'No' }}
                    </vs-td>

                    <vs-td :data="tr_qc.code">
                     {{ tr_qc.expiration_date ? __dateTimeFormatterToDate(tr_qc.expiration_date) : '-' }}
                    </vs-td>
                    <vs-td>
                    <vs-chip v-if="tr.test_type == 'Do_Not_Sample'" class="text-center text-xs" color="warning">DNS</vs-chip>
                    <div v-else>
                      <vx-tooltip v-if="tr_qc.latest_tasting_signoff" class="flex justify-start mr-2" text="View summary" position="top">
                      <vs-button class="text-center text-xs" 
                                      @click.stop="openTastePanelSummery(tr_qc)"
                                      size="small" :color="getTastePanelStatusLabelColors(tr_qc.latest_tasting_signoff.status)" >{{ tr_qc.latest_tasting_signoff.status }}</vs-button>
                                      </vx-tooltip>

                      <vx-tooltip text="View Summery" position="top" v-else-if="tr_qc.tasting_groups.length > 0">
                        <vs-button class="text-center text-xs" @click.stop="openTastePanelSummery(tr_qc)" size="small" color="warning">Pending</vs-button>
                      </vx-tooltip>
                      <vs-chip v-else class="text-center text-xs" color="warning">Pending</vs-chip>
                    </div>
                    </vs-td>
                    <vs-td>
                      <vs-chip class="text-center text-xs"  v-if="tr_qc.q_c_test" :color="getQcReleaseStatusLabelColors(tr_qc.q_c_test.q_c_status)" >{{ tr_qc.q_c_test.q_c_status }}</vs-chip>
                    <vs-chip v-else class="text-center text-xs" color="warning">Pending</vs-chip>
                    </vs-td>
                    <vs-td>
                      <div class="vx-row">
                        <vx-tooltip v-if="tr_qc.q_c_test" v-can="'create-edit-raw-material-orders-qc-test'" class="flex justify-start mr-2 ml-1" text="View QC Test" position="top">
                          <vs-button class="flex justify-end mt-1" @click="onClickUpdateQcTest(tr_qc.q_c_test.id, tr.raw_material_id)"
                                     size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="Number(tr.quantity_pending_to_receive) > 0 && tr_qc.q_c_status === 'Approved' && !tr_qc.inventory_item"
                                    text="Create a batch for this QC test" position="top" class="mr-2 ml-1">
                          <vs-button class="flex justify-end mt-1"
                                     @click.stop="onClickAddStock(tr, tr_qc.id)"
                                     size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus-square"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="tr_qc" class="mr-2 ml-1"
                                    text="View/Update RM inventory item" position="top">
                          <vs-button class="flex justify-end mt-1"
                                     @click.stop="onClickViewStock(tr_qc.id)"
                                     size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                        </vx-tooltip>
                        <div v-if="tr.test_type !== 'Do_Not_Sample'"> 
                          <vx-tooltip v-if="tr_qc.tasting_groups && tr_qc.tasting_groups.length > 0" v-can:any="['view-quality-control-tastings']" class="flex justify-start mr-2 ml-1" text="Show taste panel" position="top">
                            <vs-button class="flex justify-end mt-1" @click.stop="onClickOpenTastePanel(tr_qc)"
                                      size="small" color="warning" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                          </vx-tooltip>
                          <vx-tooltip v-else v-can:any="['view-quality-control-tastings']" class="flex justify-start mr-2 ml-1" text="Create taste panel" position="top">
                            <vs-button class="flex justify-end mt-1" @click.stop="onClickCreateTastePanel(tr_qc)"
                                      size="small" color="warning" type="border" icon-pack="feather" icon="icon-file-plus"></vs-button>
                          </vx-tooltip>
                        </div>

                        <vx-tooltip v-if="!tr_qc.q_c_test && (tr.test_type === 'Do_Not_Sample' || tr_qc.tasting_groups.length > 0)" v-can:any="['view-quality-control-tastings']" class="flex justify-start mr-2 ml-1" text="Create QC Test" position="top">
                          <vs-button class="flex justify-end mt-1" @click.stop="onClickOpenCreateQcTest(tr, tr_qc)"
                                     size="small" color="warning" type="border" icon-pack="feather" icon="icon-plus-square"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip class="flex justify-start mr-2 ml-1" text="View/Update batch notes & invoice number" position="top">
                          <vs-button class="flex justify-end mt-1" @click.stop="onClickUpdateBatchDetails(tr_qc)"
                                     size="small" color="warning" type="border" icon-pack="feather" icon="icon-file"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="tr_qc.q_c_status !== 'Rejected'" class="flex justify-start mr-2 ml-1" text="Label" position="top">
                          <vs-button class="flex justify-end mt-1" @click.stop="onClickOpenLabel(tr_qc.id)"
                                     size="small" color="danger" type="border" icon-pack="feather" icon="icon-printer"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-can:any="['view-quality-control-tastings']" class="flex justify-start mr-2 ml-1" text="Show Attachments" position="top">
                          <vs-button class="flex justify-end mt-1" @click.stop="onClickOpenTastePanelAttachments(tr_qc)"
                                     size="small" color="warning" type="border" icon-pack="feather" icon="icon-paperclip"></vs-button>
                        </vx-tooltip>
                        
                      </div>
                    </vs-td>

                  </vs-tr>
                </template>

                <!-- <template slot="thead">
                  <vs-th width="10%">DATE/TIME</vs-th>
                  <vs-th width="10%">TEST DONE BY</vs-th>
                  <vs-th width="5%">QC STATUS</vs-th>
                  <vs-th width="10%">BATCH PART NO</vs-th>
                  <vs-th width="5%">UNIT</vs-th>
                  <vs-th width="10%">QUANTITY</vs-th>
                  <vs-th width="5%">WAREHOUSED</vs-th>
                  <vs-th width="10%">BATCH EXPIRY DATE</vs-th>
                  <vs-th width="10%">INV NUMBER</vs-th>
                  <vs-th width="10%">PAYMENT STATUS</vs-th>
                  <vs-th width="15%">ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="index_qc_test" v-for="(tr_qc, index_qc_test) in data">

                    <vs-td :data="tr_qc.created_at">
                      {{ __dateTimeFormatterToDate(tr_qc.created_at) }}
                    </vs-td>

                    <vs-td :data="tr_qc.done_by">
                      {{ tr_qc.done_by }}
                    </vs-td>

                    <vs-td>
                      <vs-chip transparent :color="tr_qc.q_c_status === 'Approved' ? 'primary' : 'danger'">
                        {{ tr_qc.q_c_status || 'N/A' }}
                      </vs-chip>
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.inventory_item.batch_part_no || 'N/A' }}
                    </vs-td>

                    <vs-td>
                      {{ tr.unit }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.batch.quantity ? inventoryAvailableQuantityConvert(tr_qc.batch.quantity, tr.unit) : '' }}
                    </vs-td>

                    <vs-td class="text-bold">
                      {{ !!tr_qc.inventory_item.shelf_location_l ? 'Yes' : 'No' }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.inventory_item.expiration_date || 'N/A' }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.batch.invoice_number || 'N/A' }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.batch.payment_status || 'N/A' }}
                    </vs-td>

                    <vs-td>
                      <div class="vx-row">
                        <vx-tooltip v-can="'create-edit-raw-material-orders-qc-test'" class="flex justify-start mr-2" text="Update/View QC Test" position="top">
                          <vs-button class="flex justify-end" @click="onClickUpdateQcTest(tr_qc.id, tr.raw_material_id)"
                                     size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="Number(tr.quantity_pending_to_receive) > 0 && tr_qc.q_c_status === 'Approved' && !tr_qc.inventory_item"
                                    text="Create a batch for this QC test" position="top" class="mr-2">
                          <vs-button class="flex justify-end"
                                     @click.stop="onClickAddStock(tr, tr_qc.id)"
                                     size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus-square"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="tr_qc.inventory_item" class="mr-2"
                                    text="View/Update RM inventory item" position="top">
                          <vs-button class="flex justify-end"
                                     @click.stop="onClickViewStock(tr_qc.inventory_item.id)"
                                     size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip class="flex justify-start mr-2" text="View/Update batch notes & invoice number" position="top">
                          <vs-button class="flex justify-end" @click.stop="onClickUpdateBatchDetails(tr_qc.batch)"
                                     size="small" color="warning" type="border" icon-pack="feather" icon="icon-file"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="tr_qc.q_c_status !== 'Rejected'" class="flex justify-start mr-2" text="Label" position="top">
                          <vs-button class="flex justify-end" @click.stop="onClickOpenLabel(tr_qc.inventory_item.id)"
                                     size="small" color="danger" type="border" icon-pack="feather" icon="icon-printer"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-can:any="['view-quality-control-tastings']" class="flex justify-start mr-2" text="Show taste panel" position="top">
                          <vs-button class="flex justify-end" @click.stop="onClickOpenTastePanel(tr_qc)"
                                     size="small" color="warning" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>

                  </vs-tr>
                </template> -->

              </vs-table>

              <vs-table :hoverFlat="true" class="mt-8 mb-8" :data="tr.q_c_test">

                <template slot="header">
                  <h5 class="mb-4">RM WASTE</h5>
                </template>

                <template slot="thead">
                  <vs-th width="10%">DATE/TIME</vs-th>
                  <vs-th width="10%">QUANTITY</vs-th>
                  <vs-th width="10%">RM WASTE STATUS</vs-th>
                  <vs-th width="10%">DISPOSED DATE/TIME</vs-th>
                  <vs-th width="10%">DISPOSE NOTE</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr v-if="!!tr_qc.waste_item" :key="index_qc_test" v-for="(tr_qc, index_qc_test) in data">

                    <vs-td :data="tr_qc.created_at">
                      {{ __dateTimeFormatterToDate(tr_qc.waste_item.created_at) }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.waste_item.quantity ? inventoryAvailableQuantityConvert(tr_qc.waste_item.quantity, tr.unit) : 'N/A' }}
                    </vs-td>


                    <vs-td :data="tr_qc.waste_item.status">
                      {{ tr_qc.waste_item.status }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.waste_item.dispose_timestamp || 'N/A' }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.waste_item.dispose_note || 'N/A' }}
                    </vs-td>

                  </vs-tr>
                </template>

                </vs-table>



            </div>
          </template>

        </vs-tr>

        <vs-tr>
          <vs-td></vs-td>
          <vs-td class="font-bold" colspan="8">Total</vs-td>
          <vs-td v-if="raw_material_items[0].currency !== 'GBP'"></vs-td>
          <vs-td class="flex mr-4 float-right justify-end font-bold">{{totalCalculator()}}</vs-td>
          <vs-td></vs-td>
        </vs-tr>
      </template>

    </vs-table>
    <add-qc-test-rm-order-item-pop-up ref="addQcTestRmOrderItemPopUp"/>
    <update-qc-test-rm-order-item-pop-up ref="updateQcTestRmOrderItemPopUp"/>
    <rm-order-item-label-pop-up ref="rmOrderItemLabelPopUp"/>
    <create-rm-stock-pop-up ref="createRmStockPopUp"/>
    <update-rm-stock-pop-up v-on:refreshData="refreshData" ref="updateRmStockPopUp"/>
    <rm-order-item-batch-update-pop-up v-on:refreshData="refreshData" ref="rmOrderItemBatchUpdatePopUp"/>
    <CreateUpdateBatchQcTest v-on:refreshData="refreshData" ref="createUpdateBatchQcTest"/>
    <rm-batch-taste-panel-summery ref="rmBatchTastePanelSummery"/>
    <rm-batch-taste-panel-attachments ref="rmBatchTastePanelAttachments"/>
  </div>
</template>

<script>
  import AddQcTestRmOrderItemPopUp from "@/components/popups/inventory/rm-orders/qc-tests/AddQcTestRmOrderItemPopUp";
  import UpdateQcTestRmOrderItemPopUp from "@/components/popups/inventory/rm-orders/qc-tests/UpdateQcTestRmOrderItemPopUp";
  import CreateRmStockPopUp from "@/components/popups/manufacturing/raw-material-stock/CreateRmStockPopUp";
  import UpdateRmStockPopUp from "@/components/popups/manufacturing/raw-material-stock/UpdateRmStockPopUp";
  import RmOrderItemLabelPopUp from "@/components/popups/inventory/rm-orders/RmOrderItemLabelPopUp";
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const InventoryRepository = RepositoryFactory.get('inventory')
  import {raw_material_order_item_statuses} from '@/constants/statuses'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import router from "@/router";
  import RmOrderItemBatchUpdatePopUp from "@/components/popups/inventory/rm-orders/rm-batches/RmOrderItemBatchUpdatePopUp.vue";
  import CreateUpdateBatchQcTest from "@/components/popups/inventory/rm-orders/qc-tests/CreateUpdateBatchQcTest.vue";
  import RmBatchTastePanelSummery from "@/components/popups/inventory/rm-orders/rm-batches/RmBatchTastePanelSummery.vue";
  import RmBatchTastePanelAttachments from "@/components/popups/inventory/rm-orders/rm-batches/RmBatchTastePanelAttachments.vue";

  export default {
    name: "ProductOrderTable",
    props: {
      items: {
        type: Array,
        default: []
      },
      id: {
        type: Number,
        default:  ''
      },
      is_item_status_handled_individually: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        raw_material_order_item_statuses: raw_material_order_item_statuses,
        raw_material_items : this.items
      }
    },
    mixins : [ SuccessMessage, ErrorMessages],
    components: {
      AddQcTestRmOrderItemPopUp,
      UpdateQcTestRmOrderItemPopUp,
      RmOrderItemLabelPopUp,
      CreateRmStockPopUp,
      UpdateRmStockPopUp,
      RmOrderItemBatchUpdatePopUp,
      CreateUpdateBatchQcTest,
      RmBatchTastePanelSummery,
      RmBatchTastePanelAttachments,
    },
    methods: {
      async onClickCreateBatch(rm_item) {
        await this.$refs.addQcTestRmOrderItemPopUp.openPopup(rm_item)
      },
      async onClickOpenLabel(id) {
        await this.$refs.rmOrderItemLabelPopUp.openPopup(id)
      },
      async onClickUpdateQcTest(id, raw_material_id) {
        await this.$refs.updateQcTestRmOrderItemPopUp.openPopup(id, raw_material_id)
      },
      async onClickAddStock(item, qc_id) {
        await this.$refs.createRmStockPopUp.openPopup(item, qc_id)
      },
      async onClickViewStock(stock_id) {
        await this.$refs.updateRmStockPopUp.openPopup(stock_id)
      },
      async onClickUpdateBatchDetails(batch) {
        await this.$refs.rmOrderItemBatchUpdatePopUp.openPopup(batch)
      },
      async onClickOpenTastePanelAttachments(inventory){
        await this.$refs.rmBatchTastePanelAttachments.openPopup(inventory.id, inventory.code)
      },
      async onClickOpenTastePanel(inventory) {
        const tasting_group = this.getTastePanelForBatch(inventory)
        const route =  this.$router.resolve({
          path: '/pages/taste-panels',
          query: {open : tasting_group.id} 
        })
        window.open(route.href, '_blank')
      },
      getTastePanelStatusLabelColors(status) {
        return this.getStatusColor(status, {
          Pending: 'warning',
          Passed: 'success',
          Failed: 'danger'
        });
      },

      getQcReleaseStatusLabelColors(status) {
        return this.getStatusColor(status, {
          Pending: 'warning',
          Approved: 'success',
          Failed: 'danger'
        });
      },
      getTastePanelForBatch(inventory){
        return inventory.tasting_groups[inventory.tasting_groups.length - 1]  || null
      },
      getStatusColor(status, map) {
        if (!status) return 'dark';
        return map[status] ? map[status] : 'dark';
      },
      openTastePanelSummery(inventory){
        const panel = this.getTastePanelForBatch(inventory)
        const signOffDetails = inventory.latest_tasting_signoff
        const code = inventory.code
        this.$refs.rmBatchTastePanelSummery.openPopUp(code, panel, signOffDetails)
      },
      async onClickCreateTastePanel(inventory){
        const route = this.$router.resolve({
          path: '/pages/taste-panels',
          query: {create: inventory.code , type: 'raw_material'}
        })
        window.open(route.href, '_blank')
      },
      async onClickOpenCreateQcTest(rmDetails, inventory){
        await this.$refs.createUpdateBatchQcTest.openPopup(rmDetails,inventory )
      }, 
      totalCalculator() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          if (!!m.gbp_price) {
            total = total + Number(m.gbp_price) * Number(m.quantity)
          }
        })
        return total.toFixed(2)
      },
      itemStatusManager(status, current_status) {
        // let current_id = 0
        // if (!!current_status) {
        //   current_id = this.raw_material_order_item_statuses.find((n) => n.name === current_status).id
        // }
        // const id = this.raw_material_order_item_statuses.find((n) => n.name === status).id
        // return id > current_id;
        return true;
      },
      async refreshData(){
        this.getProductOrdersOrder()
      },
      async onClickChangeItemStatus(id, status) {
        await this.$vs.loading({
          container: '#rm-order-item-table',
          scale: 0.45
        })
        try {
          const payload = {status: status}
          await InventoryRepository.rmOrdersItemStatusChange(id, payload)
          await this.getProductOrdersOrder()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-item-table > .con-vs-loading')
      },
      async getProductOrdersOrder() {
        try{
        await this.$vs.loading({
          container: '#rm-order-item-table',
          scale: 0.45
        })
        const {data} = await InventoryRepository.getRmOrderDetails(this.id)
        this.raw_material_items = data.data.raw_material_items
        
        this.$emit('statusChangeNotify')
        this.$vs.loading.close('#rm-order-item-table > .con-vs-loading')
      }catch(e){
      }
      },
      itemStatusColorFactory(status) {
        const obj = this.raw_material_order_item_statuses.find((n) => n.name === status)
        return obj.color
      },
      statusNameFactory(status) {
        if(status === 'Received' ) {
          return 'Batch received (all/partial)'
        }
        return status
      },
      inventoryAvailableQuantityConvert(qty, unit) {
        if(unit === 'g') {
          return Number(qty) * 1000
        }
        return qty
      },
      viewRawMaterial(item){
        router.push(`/pages/manage-nimble/suppliers/${item.supplier_id}/raw-material/${item.raw_material_id}`)
      },
      //old function, before taste panel

      // generatePaymentStatus(batches) {
      //   if(batches.length === 0) return 'N/A'
      //   const firstPaymentStatus = batches.length > 0 ? batches[0].batch.payment_status : null;
      //   const allSame = batches.every(obj => obj.batch.payment_status === firstPaymentStatus);
      //   return allSame ? firstPaymentStatus : "multiple status";
      // },
       generatePaymentStatus(batches) {
        if(batches.inventory_items.length === 0) return 'N/A'
        const firstPaymentStatus = batches.inventory_items.length > 0 ? batches.payment_status : null;
        // const allSame = batches.every(obj => obj.batch.payment_status === firstPaymentStatus);
        return firstPaymentStatus
      },
    
    itemStatusGenerator(status, inventory_items, quantity_pending_to_receive) {
      try {

        if (!status || !status.includes('Received -')) {
          return status;
        }

        if (!Array.isArray(inventory_items) || inventory_items.length === 0) {
          return status;
        }

        if (Number(quantity_pending_to_receive) !== 0) {
          return 'Received - multiple QC status';
        }
        const qcStatuses = inventory_items.map(item => {
          if (
            item &&
            item.q_c_test &&
            item.q_c_test.q_c_status
          ) {
            return item.q_c_test.q_c_status;
          }
          return null;
        });
        if (qcStatuses.includes(null)) {
          return 'Received - multiple QC status';
        }
        const firstStatus = qcStatuses[0];
        const allSame = qcStatuses.every(qc => qc === firstStatus);
        if (!allSame) {
          return 'Received - multiple QC status';
        }
        return `Received - QC ${firstStatus}`;
      } catch (e) {
        return status;
      }
    }
    // itemStatusGenerator(status, qc_tests, quantity_pending_to_receive) {
    //     if (status.includes('Received -')) {
    //         if (qc_tests.length === 0) {
    //             return status;
    //         }
    //         const firstStatus = qc_tests[0].q_c_status;
    //         const allSame = qc_tests.every(obj => obj.q_c_status === firstStatus);
    //         if (Number(quantity_pending_to_receive) !== 0 || !allSame) {
    //             return 'Received - multiple QC status';
    //         }
    //         return Received - QC ${firstStatus};
    //     }
    //     return status;
    // }
    },
    watch: {
      items: function (new_value, old_value) {
        this.raw_material_items = new_value
      }
    }
  }
</script>

<style lang="scss">
  .dropdown-button-container {
    display: flex;
    align-items: center;

  .btnx {
    border-radius: 5px 0px 0px 5px;
  }

  .btn-drop {
    border-radius: 0px 5px 5px 0px;
    border-left: 1px solid rgba(255, 255, 255, .2);
  }
  }
</style>
